import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import { AppSection, CommentsSection, UpdatesSection, AboutSection } from './components/SectionsA';
import { IndexSection, CarouselSection, CardsSection, TopicsSection } from './components/SectionsB';
import { FaqSection, FeaturesSection, MediaSection, ContactSection, RankingSection } from './components/SectionsC';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <CommentsSection />
        <UpdatesSection />
        <AboutSection />
        <IndexSection />
        <CarouselSection />
        <CardsSection />
        <TopicsSection />
        <FaqSection />
        <FeaturesSection />
        <MediaSection />
        <ContactSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}